import { DoubleArrowLeftIcon } from '@radix-ui/react-icons';
import { PlayerIconButton } from './SmartPlayerUI';
import { useRewindControl } from '../hooks/usePlayerControls';
import { useTranslation } from 'react-i18next';

export const SmartPlayerRewind = () => {
    const { t } = useTranslation('smartPlayer');
    const { revSpeed, handleRewind } = useRewindControl();
    return (
        <PlayerIconButton
            active={revSpeed > 0}
            onClick={handleRewind}
            style={{ width: '32px' }}
            title={t('controls.rewind')}
        >
            {revSpeed > 0 ? (
                `-${revSpeed}x`
            ) : (
                <DoubleArrowLeftIcon width='18' height='18' />
            )}
        </PlayerIconButton>
    );
};
